import React, { useState } from "react";
import { Container } from "reactstrap";
import { useMetaMask } from "metamask-react";
import { Link, useHistory } from "react-router-dom";

import PathHelper from "../../PathHelper";

import AppConfig from "../../../../AppConfig";
import WalletTermsDialog from "../../wallet/WalletTermsDialog/WalletTermsDialog";
import DownloadMetamaskDialog from "../../wallet/DownloadMetamaskDialog/DownloadMetamaskDialog";
import WalletAvatarWidget from "../../wallet/WalletAvatarWidget/WalletAvatarWidget";
import MetamaskConfirmationDialog from "../../wallet/MetamaskConfirmationDialog/MetamaskConfirmationDialog";
import ArrowRightIcon from "../../../../components/Icon/icons/account/ArrowRightIcon";
import Icon from "../../../../components/Icon/Icon";

import s from "./MarketLogin.module.scss";

export default function MarketLogin(props) {
	const history = useHistory();
	const { user } = props;
	const { status, connect } = useMetaMask();

	const [showDialog, setShowDialog] = useState(false);
	const [showDownloadDialog, setShowDownloadDialog] = useState(false);

	const showDownloadMetamask = status === "unavailable";

	// ------------------------------------- METHODS -------------------------------------
	const connectToMetamask = () => {
		connect().then(() => {
			history.push(PathHelper.getPath("market", ""));
		});
	};

	const acceptTerms = () => {
		setShowDialog(false);

		// Not installed
		if (showDownloadMetamask) {
			setShowDownloadDialog(true);
		} else {
			connectToMetamask();
		}
	};

	const downloadMetamask = () => {
		setShowDownloadDialog(false);
		window.open(AppConfig.METAMASK_DOWNLOAD_URL, "_blank");
	};

	return (
		<Container fluid className={s.root}>
			{status === "connecting" ? <MetamaskConfirmationDialog /> : null}

			{showDialog ? (
				<WalletTermsDialog
					onContinue={acceptTerms}
					close={() => setShowDialog(false)}
				/>
			) : null}

			{showDownloadDialog ? (
				<DownloadMetamaskDialog
					onContinue={downloadMetamask}
					close={() => setShowDownloadDialog(false)}
				/>
			) : null}

			<div className={s.title}>connect wallet</div>

			{user && <WalletAvatarWidget user={user} />}

			<div className={s.connectContainer}>
				<div className={s.foxContainer} onClick={() => setShowDialog(true)}>
					<Icon icon="fox" />
					<div className={s.foxRighPanel}>
						<p className={s.meta}>Metamask</p>
						<p className={s.subTitle}>Connect using Metamask</p>
					</div>

					<ArrowRightIcon color={"#1cd0af"} />
				</div>

				<div className={s.download}>
					<p>
						Don't have a wallet?{" "}
						<a
							href={AppConfig.METAMASK_DOWNLOAD_URL}
							target="_blank"
							rel="noreferrer"
						>
							{" "}
							Download here
						</a>
					</p>
				</div>
			</div>

			<div className={s.loginContainer}>
				<p>Prefer to login with a Weavechain account? </p>
				<p>
					<Link to={PathHelper.getPath("market", "login")}>Login</Link> or{" "}
					<Link to={PathHelper.getPath("market", "register")}>Sign Up</Link>
				</p>
			</div>
		</Container>
	);
}
